import { render, staticRenderFns } from "./myMenu.vue?vue&type=template&id=4f3b2a30&scoped=true&"
import script from "./myMenu.vue?vue&type=script&lang=js&"
export * from "./myMenu.vue?vue&type=script&lang=js&"
import style0 from "./myMenu.vue?vue&type=style&index=0&id=4f3b2a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b2a30",
  null
  
)

export default component.exports